/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Tue Feb 27 2024
 **/

import styled from "@emotion/styled";

import { Column } from "../../Layouts";
import { Icon } from "../Icon";
import { Typography } from "../../Typography";

export default function FileDropArea(props: React.AllHTMLAttributes<HTMLDivElement>) {
	return (
		<Area verticalAlign="center" horizonAlign="center" gap={8} {...props}>
			<Icon name="File24" size={40} />
			<Typography typoColor="neutral_80_100" typoSize="Head6">
				Drag & drop to upload
			</Typography>
			<Typography typoColor="neutral_80_100" typoSize="Body3_MD">
				Max file size xxx MB each
			</Typography>
		</Area>
	);
}

const Area = styled(Column)`
	width: 100%;
	height: 100%;
	border: 5px dashed ${({ theme }) => theme.colors.accent_40_100};
	background: ${({ theme }) => theme.colors.accent_20_60};
	backdrop-filter: blur(30px);
`;
